<template>
  <visual-editor>
    <template #footer>@copyright 2021 linkedcare.cn All Rights Reserved</template>
  </visual-editor>
</template>
